var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTresPontinhosDetalhes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.403,
    height: 16.984,
    viewBox: "0 0 4.403 16.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tres-pontinhos-detalhes",
    d: "M104.4,28.492a2.2,2.2,0,1,1-2.2-2.2A2.2,2.2,0,0,1,104.4,28.492ZM102.2,24.4a2.2,2.2,0,1,0-2.2-2.2A2.2,2.2,0,0,0,102.2,24.4Zm0,8.178a2.2,2.2,0,1,0,2.2,2.2A2.2,2.2,0,0,0,102.2,32.581Z",
    transform: "translate(-100 -20)",
    fill: "#2d2d2d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTresPontinhosDetalhes);
export default __webpack_public_path__ + "static/media/tres-pontinhos-detalhes.ee1d1b0a533ece9fe553aee8779c3a03.svg";
export { ForwardRef as ReactComponent };